import { exampleData } from "./feature-page";

export const designData = exampleData;
